<ion-content>

  <div class="page-container">
    <div class="info-section">
    
    	<div *ngIf="!isLoading">
	      	<div class="info-title">You're all set!</div>
	      	<div class="info-description">You'll receive updates about events with code <b>{{eventCode}}</b> in channel: <b>{{channelName}}</b>.</div>
      	</div>

    	<div *ngIf="isLoading">
	      	<div class="info-title">Connecting to Slack...</div>
	      	<div *ngIf="isError" class="info-description">Error. Please try again.</div>
      	</div>

      	<hr>
    
    </div>

    <div class="images">
    	<img src="assets/img/thrillist.jpg" />
    	<img src="assets/img/massage.jpg" />
    	<img src="assets/img/nails.jpg" />
    	<img src="assets/img/recent-event-0.jpg" />
    </div>

  </div>

</ion-content>